var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmallLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 31 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M23.155.451 18.91 18.787h-5.989l-1.42-7.89-1.823 7.89H4.045L.5 5.747l5.826-1.362 1.143 7.809 1.625-8.455 4.76-1.113 1.75 9.691 1.102-10.356zM27.662 14.247h-4.52L24.863.744 30.5 3.64zm-.373 3.739a2.566 2.566 0 1 1-5.131-.001 2.566 2.566 0 0 1 5.13 0"
})));
export default SvgSmallLogo;